import { render } from "./Event.vue?vue&type=template&id=1fd56c5b"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/tools.planval.ch/tools.planval.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__